import { buildQueryString, request } from "../client"

export const fetchOrderTypes = (organizationId?: string) =>
  request<OrderType[]>(`/order-types${buildQueryString({ organization_id: organizationId })}`)

export type RestoreOrderTypeDefaultsResponse = {
  created: number
  updated: number
}

export const restoreOrderTypeDefaults = (organizationId?: string) =>
  request<RestoreOrderTypeDefaultsResponse>("/order-types/reset-defaults", {
    method: "POST",
    body: JSON.stringify({ organization_id: organizationId }),
  })

export const createOrderType = (payload: OrderTypeCreatePayload) =>
  request<OrderType>("/order-types", {
    method: "POST",
    body: JSON.stringify(payload),
  })

export const updateOrderType = (orderTypeId: string, payload: OrderTypeUpdatePayload) =>
  request<OrderType>(`/order-types/${orderTypeId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  })

export const deleteOrderType = (orderTypeId: string) =>
  request<void>(`/order-types/${orderTypeId}`, { method: "DELETE" })
